goog.provide('el8.appchart.dialog.addEditImmunization');

goog.require('el8.app.shared.clickItemOpts');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appservice.search');
goog.require('el8.appshared.form.buttons');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.service.tooltip');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.addEditImmunization');
goog.require('el8.template.test.standard');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');

el8.appchart.dialog.addEditImmunization = (function() {

    var _currImmunizationId = null; // used when editing an existing immunization
    var _declineCode = null; // used when the Pt Declined button is visible
    var successCb = null;

    var MINDREADER_WIDTH = 350;
    var STD_FIELD_LENGTH = 40;
    var LONG_FIELD_LENGTH = 100;

    var ADMINISTERED_ACTION = 'administered';
    var DECLINED_ACTION = 'patientDeclined';

    var that = new el8.uiwidget.FormDialog({
        title: 'Document Vaccination',
        autoHeight: true,
        width: 540,
        position: 'center',
        contentFn: function() {
            return el8.template.appchart.dialog.addEditImmunization.form();
        }
    });

    /*
     * Giant form definition
     */
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'partialDate',
                selector: ':input[name="partialDate"]',
                infoText: 'date...',
                datePickerOpts: {},
                changeFn: function() {
                    form.setVal('partialTime', el8.service.tz.newTzTime().asTimeString()); // 00:00:00
                },
                validate: {
                    required: true,
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'partialTime',
                selector: ':input[name="partialTime"]',
                timePickerOpts: {
                    increment: 1
                },
                defaultVal: function() { return el8.service.tz.now().asTimeString(); },
                validate: {
                    required: true,
                }
            },
            {
                name: 'manualVaccineName',
                selector: ':input[name="manualVaccineName"]',
                infoText: 'add vaccine name...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                maxLength: LONG_FIELD_LENGTH,
                mindreaderOpts: {
                    url: function() { return el8.service.urls.get('searchVaccines'); },
                    selectFn: onVaccineSelect,
                    formatResult: function(item) {
                        if (item.cdc_type && item.packaged_name) {
                            return el8.template.mindreader.commonVaccine({item: item});
                        }
                        return el8.template.mindreader.otherVaccine({item: item});
                    },
                    containerWidth: MINDREADER_WIDTH,
                    formatSelected: function(item) {
                        return el8.template.appchart.dialog.addEditImmunization.selectedVaccine(item);
                    }
                },
                newMindreader: true,
                validate: {
                    required: true
                }
            },
            {
                name: 'qty',
                selector: ':input[name="qty"]',
                infoText: 'qty...',
                maxLength: 10,
                validate: {
                    number: true
                }
            },
            {
                name: 'qtyUnits',
                selector: ':input[name="qtyUnits"]',
                infoText: 'units...',
                maxLength: STD_FIELD_LENGTH
            },
            {
                name: 'method',
                selector: ':input[name="method"]',
                infoText: 'administration method...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                mindreaderOpts: {
                    data: el8.util.consts.VACCINE_METHODS,
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true
                }
            },
            {
                name: 'site',
                selector: ':input[name="site"]',
                infoText: 'administration site...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                mindreaderOpts: {
                    data: [],
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true
                }
            },
            {
                name: 'manufacturerName',
                selector: ':input[name="manufacturerName"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'name of manufacturer...',
                mindreaderOpts: {
                    url: function() { return el8.service.urls.get('searchVaccineManufacturers'); },
                    containerWidth: MINDREADER_WIDTH,
                    formatResult: function(item) {
                        return item.name;
                    },
                    formatSelected: function(item) {
                        return item.name;
                    }
                }
            },
            {
                name: 'lotNumber',
                selector: ':input[name="lotNumber"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'lot number...'
            },
            {
                name: 'expirationDate',
                selector: ':input[name="expirationDate"]',
                infoText: 'date...',
                datePickerOpts: {}
            },
            {
                name: 'reason',
                selector: ':input[name="reason"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'reason for vaccinating...'
            },
            {
                name: 'vis',
                selector: ':input[name="vis"]',
                infoText: 'VIS(s) provided to patient...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'administeredBy',
                selector: '.administered-by-field',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'physician name...',
                clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                    newContactCb: function(contact) {
                        if (!contact) { return; }
                        form.setClickItemSelected('administeredBy', {
                            id: contact.getId(),
                            name: contact.getFullName()
                        });
                    }
                })
            },
            {
                name: 'orderedBy',
                selector: '.ordered-by-field',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'physician name...',
                clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                    newContactCb: function(contact) {
                        if (!contact) { return; }
                        form.setClickItemSelected('orderedBy', {
                            id: contact.getId(),
                            name: contact.getFullName()
                        });
                    }
                })
            },
            {
                name: 'notes',
                selector: ':input[name="notes"]',
                infoText: 'Notes...',
                height: el8.util.consts.XL_FIELD_HEIGHT
            },
            {
                name: 'publicityCode',
                selector: ':input[name="publicityCode"]'
            },
            {
                name: 'vfcEligibility',
                selector: ':input[name="vfcEligibility"]'
            },
            {
                name: 'infoSource',
                selector: ':input[name="infoSource"]'
            },
            {
                name: 'allowedSharing',
                selector: ':input[name="allowedSharing"]'
            },
            {
                name: 'declinedReason',
                selector: ':input[name="declinedReason"]'
            },
            {
                name: 'actionType',
                selector: ':input[name="actionType"]',
                changeFn: function() {
                    syncActionTypeUI();
                }
            },
            {
                name: 'packagedMedId',
                selector: ':input[name="packagedMedId"]'
            }
        ],
        firstFocusSelector: ':input[name="manualVaccineName"]',
        validationOpts: el8.util.validate.standardOpts
    });

    el8.appshared.form.buttons.addNonDraftDialogButtons(form, doSave, that);

    that.setForm(form);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        bindTriggers();
        initializeTooltips();
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        spec = spec || {};

        var patientDeclined = spec.patientDeclined;

        successCb = spec.successCb || null;
        _currImmunizationId = spec.ptImmunizationId || null;
        var currPtImmunization = _currImmunizationId ?
            el8.ptdata.ptImmunizations.getById(spec.ptImmunizationId) : null;

        form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS);
        disablePtDecline();

        // display reference information
        displayReferenceInfo();
        if (currPtImmunization) {
            populateForm(currPtImmunization);
            form.focusField('manualVaccineName');
        } else {
            that.setTitle('Document Vaccination');
            form.setVal('qtyUnits', 'ml');
            form.setVal('partialDate', el8.service.tz.now().asString());
            form.setVal('partialTime', el8.service.tz.now().asTimeString());
            if (el8.data.currUser.isPhysician()) {
                var currUserDict = {
                    id: el8.data.currUser.getStaffId(),
                    name: el8.data.currUser.getFullName()
                };
                form.setClickItemSelected('administeredBy', currUserDict);
                form.setClickItemSelected('orderedBy', currUserDict);
            }

            // searching for a vaccine keyword (e.g., cdc_type from magictable)
            if (spec.vaccineName) {
                form.setVal('manualVaccineName', spec.vaccineName, true);
                form.getInputField('manualVaccineName').focus();
                form.getMindreader('manualVaccineName').requestResults(spec.vaccineName);
            }
        }
        that.adjustPosition();
        if (patientDeclined) {
            form.setVal('actionType', DECLINED_ACTION);
            enablePtDecline();
            _declineCode = spec.vaccineName;
        } else {
            form.setVal('actionType', ADMINISTERED_ACTION);
        }
        syncActionTypeUI();
    };

    var super_hide = that.hide;
    that.hide = function() {
        $('.new-vaccine-indicator').empty().hide();
        super_hide.call(that);
        successCb = null;
        _currImmunizationId = null;
        _declineCode = null;
    };


    /*
     * Internal Methods
     */
    function validate(imm) {
        if (!form.isValid()) {
            return {result: false, msg: 'Please check the fields outlined in red.'};
        }
        if (imm.getExpirationDate() && !el8.util.datecompare.dateFromStr(form.getVal('expirationDate'))) {
            return {result: false, msg: 'Please specify a valid vaccine expiration date (or leave the field blank).'};
        }
        return {result: true};
    }

    function syncActionTypeUI() {
        // depending on whether the user is administering or declining
        // show different UI controls
        if (form.getVal('actionType') === ADMINISTERED_ACTION) {
            $('.patient-declined-action').hide();
            $('.administered-action').show();
            $('.registry-info').show();
        } else {
            $('.patient-declined-action').show();
            $('.administered-action').hide();
            $('.registry-info').hide();
        }
        that.adjustPosition();
    }

    function doSave(_form, addAnother) {
        if (form.getVal('actionType') === DECLINED_ACTION) {
            savePtDecline();
            return;
        }

        var formMap = form.getMapped();
        if (form.getMindreaderItem('manualVaccineName')) {
            formMap.vaccine_id = form.getMindreaderItem('manualVaccineName').id;
        }
        if (form.getClickItemId('administeredBy')) {
            formMap.administering_physician_id = form.getClickItemId('administeredBy');
            delete formMap.administeredBy;
        }
        if (form.getClickItemId('orderedBy')) {
            formMap.ordering_physician_id = form.getClickItemId('orderedBy');
            delete formMap.orderedBy;
        }

        var currPtImmunization = null;
        if (_currImmunizationId) {
            currPtImmunization = el8.ptdata.ptImmunizations.getById(_currImmunizationId);
            currPtImmunization.populate(formMap);
        } else {
            currPtImmunization = el8.ptdata.ptImmunizations.create(formMap, true);
        }
        currPtImmunization.setAdministeredDate(
            getSelectedDateTime()
        );
        var validated = validate(currPtImmunization);
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            return;
        }

        el8.ptdata.ptImmunizations.saveItem(currPtImmunization, false, {
            successCb: function() {
                // only add a new note if this is a new immunization, administered today, not an edit / historical entry
                if (_currImmunizationId === null &&
                        el8.util.datecompare.isSameDay(currPtImmunization.getAdministeredDate(), el8.service.tz.today()) &&
                        el8.appchart.mgr.notes.someNoteIsShowing()) {
                    el8.appchart.mgr.notes.addReference({item: currPtImmunization, sectionName: 'tx'});
                }
                if (successCb) { successCb(currPtImmunization); }
                that.hide();
                if (addAnother === true) { that.show(); }
            }
        });
    }

    function savePtDecline() {
        var mindreaderItem = form.getMindreaderItem('manualVaccineName');
        // get the cdc_type from the mindreader, if there has been a selection there, and from the
        //  pre-population we did if we opened this dialog from the magic table, if not
        var cdcType = (mindreaderItem) ? mindreaderItem.cdc_type : _declineCode;
        if (!cdcType) {
            // button should be disabled here, but there might be some cases where it slips
            el8.uiwidget.alert('Please select a vaccine with a CDC Type, from the popular list to record a decline.');
            disablePtDecline();
            return;
        }
        var declineDate = getSelectedDateTime();
        if (!declineDate) {
            el8.uiwidget.alert('Please enter a date for the immunization decline in the "Given on" field.');
            return;
        }

        var newDeclineCb = function(item) {
            if (el8.appchart.mgr.notes.someNoteIsShowing()) {
                el8.appchart.mgr.notes.addReference({item: item, sectionName: 'tx'});
            }
            that.hide();
        };
        var decline = el8.ptdata.ptImmunizationDeclines.create({
            cdcType: cdcType,
            declinedDate: declineDate,
            declinedReason: form.getVal('declinedReason'),
            vaccineId: mindreaderItem.id
        }, true);
        el8.ptdata.ptImmunizationDeclines.saveItem(
            decline,
            false,
            { successCb: newDeclineCb }
        );
    }

    function initializeTooltips() {
        el8.service.tooltip.create({
            anchor: $('.pt-declined-anchor', that.getContentElt()),
            text: el8.template.appchart.dialog.addEditImmunization.vaccDeclinedTooltip()
        });
    }

    function initializeSubmissionUI() {
        if (true /*el8Globals.FEATURES.IRSubmissions && practice-has-ir-configured*/) {
            // show controls for allowing user to select whether to report
            $('.featureIRSubmissions').show();
            // fill select with options corresponding to the current practice's IRs
            $('#aei_selectImmunizationRegistry').find('option').remove();
            // TODO list passed from el8.data.currUser(?) or pulled from internal API

            $.el8_ajax({
                url: el8.service.urls.get('getRegistryIntegrations'),
                type: 'GET',
                success: function(data) {
                    if (!data) { return; }
                    var practiceIRs = data.sort(function(a,b) {
                        if (a.region < b.region) { return -1 } else { return 1; }
                    });
                    practiceIRs.forEach(function(ir) {
                        $('#aei_selectImmunizationRegistry').append(new Option("(" + ir.code + ") " + ir.description, ir.integration_id));
                    });
        }
            });
        } else {
            $('.featureIRSubmissions').hide();
        }
    }

    function enablePtDecline() {
        $('.pt-declined-check', that.getContentElt()).prop('disabled', false);
    }
    function disablePtDecline() {
        $('.pt-declined-check', that.getContentElt()).prop('disabled', true);
    }

    function bindTriggers() {

        /* Show an "unknown vaccine" error for any Vaccine field that is not:
         *  (1) empty, (2) chosen from the mindreader, (3) in the process of being replaced by the mindreader */
        that.getContentElt().on('change', ':input[name="manualVaccineName"]',  function(e) {
            var mindreaderItem = form.getMindreaderItem('manualVaccineName');
            if (mindreaderItem) {
                $('.new-vaccine-indicator').empty().hide();
                if (mindreaderItem.cdc_type) { enablePtDecline(); }

            } else if (form.getField('manualVaccineName').getVal() === '') {
                form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS);
                $('.new-vaccine-indicator').empty().hide();
                disablePtDecline();

            } else {
                form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS); //reset Method for unknown vaccine
                $('.new-vaccine-indicator').show().html(
                    el8.template.appchart.dialog.addEditImmunization.unknownVaccine()
                );
                disablePtDecline();
            }
        });

        /* The Site field shows/hides and has auto-complete options based on the Method field */
        that.getContentElt().on('change', ':input[name="method"]',  function(e) {
            var method = form.getField('method').getVal().toLowerCase().trim();
            if (!isSiteFieldRelevant(method)) {
                form.hideField('site'); /* the field is redundant for oral and intranasal vaccines */
                form.getField('site').setVal('');
            } else {
                form.showField('site'); //in case the field was previously hidden

                /* set Site field autocomplete options */
                if (method === 'subcutaneous' || method === 'sc' || method === 'subcutaneous (sc)') {
                    form.setMindreaderSearchData('site', el8.util.consts.VACCINE_SUBCUTANEOUS_SITES);
                } else if (method === 'intramuscular' || method === 'im' || method === 'intramuscular (im)') {
                    form.setMindreaderSearchData('site', el8.util.consts.VACCINE_INTRAMUSCULAR_SITES);
                } else {
                    form.setMindreaderSearchData('site', []);
                }
            }
        });

        that.getContentElt().on('click', '.educational-handouts-trigger',  function(event) {
            event.preventDefault();
            el8.appshared.dialog.viewEducationalHandouts.show();
        });

        el8.uiwidget.collapsible({
            container: $('.imm-reg-info-collapse', that.getContentElt()),
            triggerElt: $('#imm-reg-info-header'),
            statusElt: $('#imm-reg-info-status'),
            isCollapsed: true,
            expandFn: function() { that.adjustHeight(); },
            collapseFn: function() { that.adjustHeight(); }
        });
    }

    function getSelectedDateTime() {
        return el8.service.tz.processDateAndTimeInputs(form.getVal('partialDate'), form.getVal('partialTime'));
    }

    /* Oral and Intranasal methods are associated with exactly one site */
    function isSiteFieldRelevant(method) {
        method = method.toLowerCase().trim();
        return (method !== 'oral' && method !== 'po' && method !== 'oral (po)' &&
                method !== 'intranasal' && method !== 'nas' && method !== 'intranasal (nas)' && method !== 'nasal');
    }

    /* Pull the relevant string out of the array of patient_type/dose string pairs
     * that comes down from the server */
    function getDisplayDose(doses, age) {
        if (!doses) { return; }
        var patientType = '';
        var displayDose = '';

        if (age <= el8.util.consts.PATIENT_TYPE_MAX_AGE_MAP['infant']) {
            patientType = 'infant';
        } else if (age <= el8.util.consts.PATIENT_TYPE_MAX_AGE_MAP['children']) {
            patientType = 'children';
        } else {
            patientType = 'adult';
        }
        for (var i = 0; i < doses.length; i++) {
            if (doses[i].patient_type && doses[i].patient_type === patientType) {
                displayDose = doses[i].dose;
            }
        }

        return (displayDose && displayDose.toLowerCase() !== 'none') ? displayDose : null;
    }


    /* mindreader selectFn: fill out any fields we can based on the vaccine selected */
    function onVaccineSelect(event, item) {
        var autocompleteFromObject = function(fieldName, fieldData) {
            if (!fieldData) { return; }
            form.getField(fieldName).setVal(fieldData);
            form.getField(fieldName).getInputField().change();
        };
        var selectedVaccine = form.getMindreaderItem('manualVaccineName');
        if (!selectedVaccine || !selectedVaccine.id) { return; }
        $.el8_ajax({
            url: el8.service.urls.get('vaccinePreferences', [selectedVaccine.id, selectedVaccine.packaged_med_id]),
            type: 'GET',
            success: function(data) {
                if (!data) { return; }
                autocompleteFromObject('lotNumber', data.lot_number);
                autocompleteFromObject('expirationDate', data.expiration_date);
                autocompleteFromObject('qty', data.qty);
                autocompleteFromObject('qtyUnits', data.qty_units);
                autocompleteFromObject('manufacturerName', data.manufacturer_name);
            }
        });
        autocompleteFromObject('packagedMedId', selectedVaccine.packaged_med_id);
        autocompleteFromObject('method', selectedVaccine.route);
        autocompleteFromObject('manufacturerName', selectedVaccine.manuf_name);
        item.display_dose = getDisplayDose(item.doses, el8.ptdata.currPatient.getAge());
        if (selectedVaccine.display_dose) {
            var splitQty = selectedVaccine.display_dose.split(" ");
            if (splitQty && splitQty.length === 2) {
                autocompleteFromObject('qty', splitQty[0]);
                autocompleteFromObject('qtyUnits', splitQty[1]);
            }
        }
    }

    function populateForm(ptImmunization) {
        that.setTitle('Edit Vaccination');
        if (isSiteFieldRelevant(ptImmunization.getMethod())) {
            form.showField('site');
        }

        var formMap = ptImmunization.asSoyMap();
        form.populate(formMap);

        form.setVal('manualVaccineName', formMap.description);
        form.setVal('partialDate', ptImmunization.getAdministeredDate().asString());
        form.setVal('partialTime', ptImmunization.getAdministeredDate().asTimeString());

        if (ptImmunization.getAdministeringPhysicianId()) {
            form.setClickItemSelected('administeredBy', {
                id: ptImmunization.getAdministeringPhysicianId(),
                name: ptImmunization.getAdministeringPhysicianName()
            });
        }
        if (ptImmunization.getOrderingPhysicianId()) {
            form.setClickItemSelected('orderedBy', {
                id: ptImmunization.getOrderingPhysicianId(),
                name: ptImmunization.getOrderingPhysicianName()
            });
        }
    }

    function displayReferenceInfo() {
        /**
         * Do all the styling of the way allergies + drug intols are displayed
         */

        var patientInfoDiv = $('#add-edit-immunization-form-cds');
        var makeContainerRed = false;

        /**
         * Update display
         */
        $('.allergy-values', patientInfoDiv).text(el8.ptdata.ptAllergies.getSummary());
        $('.intolerance-values', patientInfoDiv).html(el8.ptdata.ptIntolerances.getSummary());

        // If there are no known allergies, then make grey
        if (el8.ptdata.ptAllergies.isDocumentedAsNone()) {
            $('.pt-allergies', patientInfoDiv).addClass('el8555');
        } else { // else, make red if there are known allergies OR if they are unknown!
            makeContainerRed = true;
            $('.pt-allergies', patientInfoDiv).removeClass('el8555');
        }

        if (makeContainerRed) {
            patientInfoDiv.addClass('alert');
        } else {
            patientInfoDiv.removeClass('alert');
        }

        // If patient intols is more than 5 a toggles will appear to show the remaining intols.
        if (el8.ptdata.ptIntolerances.all().length > 5) {

            var comma = patientInfoDiv.find('.comma-separator');
            var moreIntols = patientInfoDiv.find('.more-intols');
            var moreIntolsTrigger = patientInfoDiv.find('.more-intols-trigger');

            comma.hide();
            moreIntols.hide();

            $(patientInfoDiv)
                .on('click', '.more-intols-trigger',  function(e) {
                    comma.show();
                    moreIntols.show();
                    moreIntolsTrigger.hide();
                    return false;
                })
                .on('click', '.less-intols-trigger',  function(e) {
                    comma.hide();
                    moreIntols.hide();
                    moreIntolsTrigger.show();
                    return false;
                });
        }
    }

    return that;

})();
